import { LeadForm } from "@2u-landing-pages/components";
import React from "react";
import styles from "./Hero.module.scss";

export const Hero = React.forwardRef((props, ref) => {
  return (
    <>
      <link
        rel="preload"
        fetchPriority="high"
        href="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_hero_1_m.jpg"
        as="image"
        media="(max-width: 767px)"
      />
      <link
        rel="preload"
        fetchPriority="high"
        href="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_hero_1.jpg"
        as="image"
        media="(min-width: 768px)"
      />
      <section ref={ref} className={`${styles.container} cc--component-container`}>
        <div className={styles.container_wrapper}>
          <main className={styles.container_main}>
            <h1 className={styles.headline}>Become a Digital Defender</h1>
            <h2 className={styles.subheadline}>
              Columbia Engineering Cybersecurity Boot&nbsp;Camp <span className={styles.title_border}>|</span> <br />
              Learn&nbsp;Cybersecurity in&nbsp;24&nbsp;Weeks
            </h2>
            <section className="cc--component-container">
              <ul className={styles.hero_feature_list}>
                <li>
                  <strong>Global Network:</strong> Gain access to a network of 250+ employers looking to&nbsp;hire.
                </li>
                <li>
                  <strong>CompTIA Partnership:</strong> Get a head start on certification test&nbsp;prep.
                </li>
                <li>
                  <strong>Learner Success:</strong> Stay on track with personalized academic&nbsp;support.
                </li>
                <li>
                  <strong>Career Support:</strong> Access free professional resources throughout&nbsp;your&nbsp;career.
                </li>
              </ul>
            </section>
          </main>
          <aside className={styles.container_aside}>
            <div className={`${styles.container_form} rv-lead-form`}>
              <LeadForm packageId="2663" enableStyles={false} />
            </div>
          </aside>
        </div>
      </section>
      <section className={`${styles.hero_banner} cc--component-container`}>
        <ul>
          <li>
            <span>Next Start Date:</span>
            <br />
            <strong>November 13, 2024</strong>
          </li>
          <li>
            <span>Time to Complete:</span>
            <br />
            <strong>24 Weeks, part-time</strong>
          </li>
          <li>
            <span>Live Online Classes:</span>
            <br />
            <strong>9 hours per week</strong>
          </li>
        </ul>
      </section>
    </>
  );
});

Hero.displayName = "Hero";
